export const getScrollYToCenterDelta = (
  parentEl: Element,
  childEl: Element
): number => {
  const pr = parentEl.getBoundingClientRect()
  const cr = childEl.getBoundingClientRect()
  const py = (pr.top + pr.bottom) / 2
  const cy = (cr.top + cr.bottom) / 2
  return cy - py
}

export const getScrollYToTopDelta = (
  parentEl: Element,
  childEl: Element
): number => {
  const pr = parentEl.getBoundingClientRect()
  const cr = childEl.getBoundingClientRect()
  return cr.top - pr.top
}

export const isVisibleYInParent = (
  parentEl: Element,
  childEl: Element
): boolean => {
  const pr = parentEl.getBoundingClientRect()
  const cr = childEl.getBoundingClientRect()
  return pr.top <= cr.top && pr.bottom >= cr.bottom
}

export const insideRect = (x: number, y: number, r: DOMRect): boolean =>
  r.left <= x && x <= r.right && r.top <= y && y <= r.bottom
